module.exports = __webpack_public_path__ + "img/youtube.6dfb211b.png";